export default __webpack_public_path__ + "static/media/check.a36ba616.svg";